import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PaymentType } from '../../../../enums/payment-type.enum';
import { UnitBankAccountReqRes } from '../../../../models/gp/UnitBankAccountReqRes.model';
import { PaymentReadDto } from '../models/payment/payment-read-dto.model';
import { UnitPaymentCategory } from '../models/unit-payment-category.enum';
import { UnitPaymentStatus } from '../models/unit-payment-status.enum';

@Component({
  selector: 'terra-unit-payment-details',
  templateUrl: './unit-payment-details.component.html',
  styleUrls: ['./unit-payment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitPaymentDetailsComponent {
  @Input() payment: PaymentReadDto;
  @Input() sourceBankAccount: UnitBankAccountReqRes;

  // enums
  UnitPaymentType = PaymentType;
  UnitPaymentCategory = UnitPaymentCategory;
  UnitPaymentStatus = UnitPaymentStatus;

  get balanceAfterTransaction(): number {
    return (this.sourceBankAccount.available / 100) - this.payment.amount;
  }

  get dateOfTransaction(): string {
    const transactionDate = !!this.payment.paymentSentTimestamp ? new Date(this.payment.paymentSentTimestamp) : new Date();
    return transactionDate.toLocaleDateString('en-US');
  }
}
